import React from "react";
import { Link } from "@quintype/components";
import { object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import { staticTexts } from "../../utils/Translate";

import "./fileAttachment.m.css";

const FileAttachment = ({ element, publisherAttributes }) => (
  <div styleName={`file-attachment-wrapper ${publisherAttributes.lang}-wrapper`}>
    <div styleName="file-name">{element["file-name"]}</div>
    <div styleName="download-link">
      <Link href={element.url}>{staticTexts(publisherAttributes.lang).download}</Link>
    </div>
  </div>
);

FileAttachment.propTypes = {
  element: object,
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps, null)(FileAttachment);
